export const defaultEmailTemplates = {
  registrationSubject: 'Sikeres jelentkezés a csapatedzésre ({{trainingDate}})',
  registrationBody:
    'Kedves {{displayName}}!\n\n' +
    'Rögzítettük a jelentkezésedet.\n\n' +
    'Edzés napja: {{trainingDate}}\n' +
    'Edzés kezdete: {{trainingStartAt}}\n' +
    'Jelentkezés ideje: {{createdAt}}\n' +
    'Jelentkezés azonosító: {{registrationId}}',
  registrationCalendarDescription:
    'Sikeres jelentkezés a csapatedzésre ({{trainingDate}}). Jelentkezési azonosító: {{registrationId}}.',

  userCancellationSubject: 'Sikeres lemondás a csapatedzésről ({{trainingDate}}) [ID: {{registrationId}}]',
  userCancellationBody:
    'Kedves {{displayName}}!\n\n' +
    'A lemondást rögzítettük, a helyed felszabadult erre az alkalomra.\n\n' +
    'Edzés napja: {{trainingDate}}\n' +
    'Edzés kezdete: {{trainingStartAt}}\n' +
    'Lemondás ideje: {{cancelledAt}}\n' +
    'Eredeti jelentkezés ideje: {{originalCreatedAt}}\n' +
    'Jelentkezés azonosító: {{registrationId}}',
  userCancellationCalendarReason: 'A csapatedzés jelentkezésedet lemondtad.',

  adminCancellationUserSubject: 'Edzés lemondva: {{trainingDate}}',
  adminCancellationUserBody:
    'Kedves {{displayName}}!\n\n' +
    'Sajnáljuk, a(z) {{trainingDate}} dátumú csapatedzés szervezői okból lemondásra került.\n\n' +
    'Edzés napja: {{trainingDate}}\n' +
    'Edzés kezdete: {{trainingStartAt}}\n' +
    'Lemondás rögzítve: {{cancelledAt}}\n' +
    'Jelentkezés azonosító: {{registrationId}}',
  adminCancellationCalendarReason: 'A csapatedzés szervezői okból lemondásra került.',

  adminCancellationSummarySubject: 'Admin értesítés: edzés lemondva ({{trainingDate}})',
  adminCancellationSummaryBody:
    'Admin edzéslemondási értesítés\n\n' +
    'Szervezői lemondás lett rögzítve.\n\n' +
    'Edzés napja: {{trainingDate}}\n' +
    'Lemondás rögzítve: {{cancelledAt}}\n' +
    'Érintett jelentkezők száma: {{registrationCount}}\n\n' +
    '{{registrationList}}',

  adminRegistrationRemovalSubject: 'Jelentkezésed törölve lett: {{trainingDate}}',
  adminRegistrationRemovalBody:
    'Kedves {{displayName}}!\n\n' +
    'A(z) {{trainingDate}} dátumú csapatedzésre leadott jelentkezésedet admin törölte.\n\n' +
    'Edzés napja: {{trainingDate}}\n' +
    'Edzés kezdete: {{trainingStartAt}}\n' +
    'Törlés ideje: {{cancelledAt}}\n' +
    'Eredeti jelentkezés ideje: {{originalCreatedAt}}\n' +
    'Jelentkezés azonosító: {{registrationId}}',
  adminRegistrationRemovalCalendarReason: 'A csapatedzés jelentkezésedet admin törölte.',

  waitlistOfferSubject: 'Felszabadult egy hely a csapatedzésen ({{trainingDate}})',
  waitlistOfferBody:
    'Kedves {{displayName}}!\n\n' +
    'Felszabadult egy hely a(z) {{trainingDate}} dátumú csapatedzésen.\n\n' +
    'Kérlek, jelezz vissza a lenti linkek egyikével.\n\n' +
    'Fontos: az e-mail kiküldésétől számított 2 órád van reagálni. Ha addig nem válaszolsz, ' +
    'a várólistán következő jelentkező is megkapja a lehetőséget, és onnantól az kerül be a normál jelentkezők közé, ' +
    'aki hamarabb nyom a Jövök! linkre.\n\n' +
    'Jövök!: {{acceptUrl}}\n' +
    'Nem jövök.: {{declineUrl}}\n\n' +
    'Edzés kezdete: {{trainingStartAt}}\n' +
    'Válaszadási határidő: {{responseDeadline}}',

  trainingReminderSubject: 'Még van hely a következő csapatedzésen ({{trainingDate}})',
  trainingReminderBody:
    'Kedves {{displayName}}!\n\n' +
    'A következő csapatedzésen még van szabad hely.\n\n' +
    'Edzés napja: {{trainingDate}}\n' +
    'Edzés kezdete: {{trainingStartAt}}\n' +
    'Szabad helyek száma: {{availableSpots}}\n\n' +
    'Jelentkezés itt: {{registrationUrl}}',

  accountVerificationSubject: 'Erősítsd meg a PNG Squash fiókodat',
  accountVerificationBody:
    'Kedves {{displayName}}!\n\n' +
    'Köszönjük a regisztrációt. A belépéshez előbb erősítsd meg az e-mail címedet az alábbi linken:\n\n' +
    '{{verificationUrl}}\n\n' +
    'Ha nem te regisztráltál a PNG Squash oldalán, ezt az e-mailt figyelmen kívül hagyhatod.',
};

export const emailTemplateSections = [
  {
    title: 'Jelentkezés visszaigazoló e-mail',
    description: 'Akkor megy ki, amikor valaki jelentkezik egy edzésre.',
    fields: [
      { key: 'registrationSubject', label: 'Jelentkezés visszaigazoló e-mail tárgya' },
      { key: 'registrationBody', label: 'Jelentkezés visszaigazoló e-mail szövege', multiline: true, rows: 9 },
      { key: 'registrationCalendarDescription', label: 'Jelentkezés naptármeghívó leírása', multiline: true, rows: 4 },
    ],
  },
  {
    title: 'Felhasználói lemondás visszaigazoló e-mail',
    description: 'Akkor megy ki, amikor a jelentkező maga mondja le a részvételt.',
    fields: [
      { key: 'userCancellationSubject', label: 'Felhasználói lemondás e-mail tárgya' },
      { key: 'userCancellationBody', label: 'Felhasználói lemondás e-mail szövege', multiline: true, rows: 9 },
      { key: 'userCancellationCalendarReason', label: 'Felhasználói lemondás naptár törlési oka', multiline: true, rows: 3 },
    ],
  },
  {
    title: 'Admin által lemondott edzés e-mail a jelentkezőknek',
    description: 'Akkor megy ki a jelentkezőknek, amikor admin mond le egy teljes edzést.',
    fields: [
      { key: 'adminCancellationUserSubject', label: 'Admin lemondás jelentkezői e-mail tárgya' },
      { key: 'adminCancellationUserBody', label: 'Admin lemondás jelentkezői e-mail szövege', multiline: true, rows: 8 },
      { key: 'adminCancellationCalendarReason', label: 'Admin lemondás naptár törlési oka', multiline: true, rows: 3 },
    ],
  },
  {
    title: 'Admin által lemondott edzés összefoglaló e-mail adminnak',
    description: 'Akkor megy ki az adminnak, amikor admin mond le egy teljes edzést.',
    fields: [
      { key: 'adminCancellationSummarySubject', label: 'Admin lemondás összefoglaló e-mail tárgya' },
      { key: 'adminCancellationSummaryBody', label: 'Admin lemondás összefoglaló e-mail szövege', multiline: true, rows: 9 },
    ],
  },
  {
    title: 'Admin által törölt jelentkezés e-mail',
    description: 'Akkor megy ki, amikor admin töröl egy jelentkezőt egy edzésről.',
    fields: [
      { key: 'adminRegistrationRemovalSubject', label: 'Admin jelentkezés törlés e-mail tárgya' },
      { key: 'adminRegistrationRemovalBody', label: 'Admin jelentkezés törlés e-mail szövege', multiline: true, rows: 9 },
      { key: 'adminRegistrationRemovalCalendarReason', label: 'Admin jelentkezés törlés naptár törlési oka', multiline: true, rows: 3 },
    ],
  },
  {
    title: 'Várólistás helyfelajánló e-mail',
    description: 'Akkor megy ki, amikor egy normál jelentkező lemondása miatt felszabadul egy várólistának fenntartott hely.',
    fields: [
      { key: 'waitlistOfferSubject', label: 'Várólistás helyfelajánló e-mail tárgya' },
      { key: 'waitlistOfferBody', label: 'Várólistás helyfelajánló e-mail szövege', multiline: true, rows: 12 },
    ],
  },
  {
    title: 'Szabad hely emlékeztető e-mail',
    description: '48 órával a következő edzés előtt megy ki azoknak a regisztrált felhasználóknak, akik még nem jelentkeztek.',
    fields: [
      { key: 'trainingReminderSubject', label: 'Szabad hely emlékeztető e-mail tárgya' },
      { key: 'trainingReminderBody', label: 'Szabad hely emlékeztető e-mail szövege', multiline: true, rows: 9 },
    ],
  },
  {
    title: 'Fiók e-mail cím megerősítő e-mail',
    description: 'E-mailes regisztrációkor és nem megerősített e-maillel történő belépési próbálkozáskor megy ki.',
    fields: [
      { key: 'accountVerificationSubject', label: 'Fiókmegerősítő e-mail tárgya' },
      { key: 'accountVerificationBody', label: 'Fiókmegerősítő e-mail szövege', multiline: true, rows: 8 },
    ],
  },
];

export const emailTemplatePlaceholders = [
  '{{displayName}}',
  '{{trainingDate}}',
  '{{trainingStartAt}}',
  '{{createdAt}}',
  '{{cancelledAt}}',
  '{{originalCreatedAt}}',
  '{{registrationId}}',
  '{{registrationCount}}',
  '{{registrationList}}',
  '{{acceptUrl}}',
  '{{declineUrl}}',
  '{{responseDeadline}}',
  '{{availableSpots}}',
  '{{registrationUrl}}',
  '{{verificationUrl}}',
];

export const pickEmailTemplates = (source = {}) => {
  const picked = {};
  Object.keys(defaultEmailTemplates).forEach((key) => {
    if (typeof source[key] === 'string') {
      picked[key] = source[key];
    }
  });
  return picked;
};
